//  漢堡按鈕
'use client';
import { usePathname, useParams } from 'next/navigation';
import { IS_LIST_PATH } from '@/common/constant';
import { useDispatch, useSelector } from 'react-redux';
import { setShowMenu, popState } from '@/slices/popSlice';
import Image from 'next/image';

const HamburgerButton = () => {
    const dispatch = useDispatch();
    const { showMenu } = useSelector(popState);
    const pathname = usePathname();
    const params = useParams();
    const { newsSlug } = params;

    // 特定路徑判斷
    const isListPath = IS_LIST_PATH.includes(pathname) && !newsSlug;

    const onToggle = () => dispatch(setShowMenu(!showMenu));

    return (
        <button className="img-box w-[30px] h-[30px] trans hover:opacity-[.7]" onClick={onToggle}>
            <Image
                className={isListPath ? '' : 'dark-hidden'}
                width={30}
                height={30}
                src="/images/icon/icon_hamburger.svg"
                alt="icon"
            />
            {!isListPath && (
                <Image
                    className="hidden dark:block"
                    width={30}
                    height={30}
                    src="/images/icon/icon_dark_hamburger.svg"
                    alt="icon"
                />
            )}
        </button>
    );
};

export default HamburgerButton;
